import { IconStarFilled } from '@tabler/icons-react'
import type { JSX } from 'react'

// Marks the one language a profile prefers, mirroring the star the languages
// dropdown toggles.
//
// The Figma frame draws this as a "★" text glyph, which DM Sans has no glyph
// for — a literal star character would fall back to a per-OS system font. So
// this is the icon, sized and raised to land on the glyph's pixels: at the
// header's 12px text the ink measures 5px wide, ~7.9px², and sits 4px above
// the baseline (the glyph is superscript-high, not baseline-seated). Sizes are
// em so both the 12px header row and the 14px Contact card keep that
// proportion; ml-px is the side bearing the glyph would have carried.
export function PreferredLanguageStar(): JSX.Element {
  return (
    <IconStarFilled
      role="img"
      aria-label="Preferred language"
      className="ml-px inline size-[0.458em] align-[0.3em]"
    />
  )
}
